<template>
    <div class="main-box" :class="{'mask-layer':checkoutSucceed}">
        <div class="box-wrap" v-show="cartList.length>0">
            <div class="box-header" style="height: 52px">
                <i class="el-icon-close" @click="$emit('componentIndex',0)"></i>
                <span>Cart</span>
            </div>
            <div class="box-content" style="height: calc(100% - 104px)">
                <scroll-wrap>
                    <div class="box-content-wrap">
                        <div class="title">
                            Shipping and Payment
                        </div>
                        <div class="ship-wrap">
                            <el-collapse v-model="closeCollapse" accordion>
                                <el-collapse-item name="1">
                                    <div slot="title" class="ship-title">
                                        <span style="margin-left: 12px">
                                            Ship to
                                        </span>
                                        <span style="color: #089bab;margin-right: 6px">
                                            {{ addressName }}
                                        </span>
                                    </div>
                                    <div slot="default" class="ship-default">
                                        <div class="ship-default-add" @click="$emit('componentIndex',5)">
                                            <i class="el-icon-add-location"></i>
                                            <span>Add New Address</span>
                                        </div>
                                        <el-radio-group v-model="defaultAddressRadio" @change="updateDefaultAddress">
                                            <div class="address-wrap" v-for="(item,index) in $store.state.address.items"
                                                 :key="index">
                                                <el-radio :label="item.id">
                                                    <div class="receipt-list">
                                                    <span v-for="(itemm,indexx) in JSON.parse(item.receipt)"
                                                          :key="indexx">
                                                        {{itemm}}
                                                    </span>
                                                    </div>
                                                </el-radio>
                                            </div>
                                        </el-radio-group>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                        <div class="title">
                            Items in Cart
                        </div>
                        <div class="product-list">
                            <div class="item" v-for="(item,index) in cartList" :key="index"
                                 :class="{stockout:item.product.inventory===0}">
                                <div class="img">
                                    <img :src="item.product.image" alt="">
                                </div>
                                <div class="product-info">
                                    <div class="product-title">
                                        {{item.product.title}}
                                    </div>
                                    <div class="product-shipping">
                                        Shipping:${{item.product.logistic}}
                                    </div>
                                    <div class="product-timeliness">
                                        Ships from warehouse {{item.product.timeliness}}
                                    </div>
                                </div>
                                <div class="product-price">
                                    <div class="promotion-price">
                                        <span class="promotionPrice" v-if="item.product.status!==2">${{item.product.price}}</span>
                                        <span class="promotionPrice" v-else-if="(Date.now()> item.product.startTime )&&(Date.now()<item.product.endTime)">${{item.product.promotionPrice}}</span>
                                        <span class="promotionPrice" v-else>${{item.product.price}}</span>

                                        <span class="isPromotion" v-if="item.product.status!==2">${{item.product.msrp}}</span>
                                        <span class="isPromotion" v-else-if="(Date.now()> item.product.startTime )&&(Date.now()<item.product.endTime)">${{item.product.price}}</span>
                                        <span class="isPromotion" v-else>${{item.product.msrp}}</span>

                                    </div>
                                    <div class="product-num">
                                        <el-select size="mini" v-model="item.amount" placeholder="请选择" @change="verify(item)">
                                            <el-option
                                                    :label="0"
                                                    :value="0">
                                            </el-option>
                                            <el-option
                                                    v-for="(itemm,indexx) in item.product.inventory>99?99:item.product.inventory"
                                                    :key="itemm"
                                                    :label="itemm"
                                                    :value="itemm">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="stockout-wrap" v-if="item.product.inventory===0">
                                    <span class="btnn" @click="removeItem(item.product)">
                                        RemoveItem
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="title">
                            Order Summary
                        </div>
                        <div class="order-summary">
                            <div class="">
                                <span>Item Total</span>
                                <span>${{itemTotal.toFixed(2)}}</span>
                            </div>
                            <div class="">
                                <span>Shipping</span>
                                <span>${{shipping.toFixed(2)}}</span>
                            </div>
                            <div>
                                <span>Order Total</span>
                                <span>${{orderTotal.toFixed(2)}}</span>
                            </div>
                        </div>
                        <div class="buy-info">
                            By tapping 'Checkout' you agree to the Terms of Use and Privacy Policy
                            <div style="margin: 10px 0;width: 100%;height: 1px;background: #ebeef5"></div>
                            <div>
                                30 Day Free Return and Refund
                            </div>
                        </div>
                    </div>
                </scroll-wrap>
                <div class="message-alert" :class="{'active':checkoutSucceed}">
                    <div class="img">
                        <img src="./../../assets/images/dagou.png" alt="" width="60px">
                    </div>
                </div>
            </div>
            <div class="box-footer" style="height: 52px">
            <span class="pay" @click="checkout">
                Checkout
            </span>
            </div>
        </div>
        <div class="box-wrap empty" v-show="cartList.length<1">
            <div class="box-header" style="height: 52px">
                <i class="el-icon-close" @click="$emit('componentIndex',0)"></i>
                <span>Cart</span>
            </div>
            <div class="box-content" style="height: calc(100% - 52px)">
                <div class="empty">
                <span class="icon">
                    <i class="icongouwuche iconfont"></i>
                </span>
                    <span class="txt">Your cart is empty</span>
                    <span class="btn" @click="$emit('componentIndex',0)">
                        Continue Shopping
                    </span>
                </div>
            </div>
        </div>
        <phone-affirm v-if="affirmData.show" @close="affirmData.show = false"
                      :data="affirmData">
            <template slot="content">
                <div style="font-size: 14px;font-weight: bolder;margin: 10px 0">
                    <h3 style="text-align: center">Are you sure ?</h3>
                    <div style="font-weight:normal;text-align: center;line-height: 22px">
                        Do you want to remove this item from your cart?
                    </div>
                </div>
            </template>
            <template slot="footer">
                <span @click="affirmReceipt(affirmData)">
                    Yes
                </span>
                <span @click="affirmData.show = false" style="background: none;color:#00BCD4">
                    No
                </span>
            </template>
        </phone-affirm>
        <phone-affirm v-if="warning" @close="warning = false">
            <template slot="content">
                <div style="font-size: 14px;font-weight: bolder;margin: 10px 0">
                    <h3 style="text-align: center">You have not added the shipping address!</h3>
                    <div style="font-weight:normal;text-align: center;line-height: 22px">
                        Do you want to add a new shipping address?
                    </div>
                </div>
            </template>
            <template slot="footer">
                <span @click="$emit('componentIndex',5)">
                    Yes
                </span>
            </template>
        </phone-affirm>
        <phone-affirm v-if="warning2" @close="warning2 = false">
            <template slot="content">
                <div style="font-size: 14px;font-weight: bolder;margin: 10px 0">
                    <h3 style="text-align: center">The shopping cart is empty or the items purchased are out of stock!</h3>
                    <div style="font-weight:normal;text-align: center;line-height: 22px">
                        Do you want to continue Shopping?
                    </div>
                </div>
            </template>
            <template slot="footer">
                <span @click="$emit('componentIndex',0)">
                    Yes
                </span>
            </template>
        </phone-affirm>
    </div>
</template>

<script>
    import PhoneAffirm from "./PhoneAffirm"
    export default {
        name: "Shopping-Cart",
        components:{
            PhoneAffirm
        },
        data() {
            return {
                productList: [],
                checkoutSucceed: false,
                closeCollapse:'',
                affirmData:{
                    show:false
                },
                warning:false,
                warning2:false
            }
        },
        created() {
            this.$store.dispatch('getCart');
            this.$store.dispatch('getAddress')
        },
        computed: {
            addressName: {
                get: function () {
                    if (this.$store.state.address.isDefault) {
                        return JSON.parse(this.$store.state.address.isDefault.receipt).addressline1
                    }
                    return ''
                }
            },
            defaultAddressRadio: {
                get: function () {
                    if (this.$store.state.address.isDefault) {
                        return this.$store.state.address.isDefault.id
                    }
                    return ''
                },
                set: function (value) {
                    this.$store.dispatch('updateDefaultAddress', {id: value});
                    this.closeCollapse = ''
                },
            },
            cartList: function () {
                return this.$store.state.cart
            },
            itemTotal: function () {
                let $total = 0;
                this.cartList.forEach(item => {
                    if (item.product.inventory === 0) return false;
                    let $price = item.product.status === 2 && (Date.now() > item.product.startTime)  && (Date.now() < item.product.endTime) ? item.product.promotionPrice : item.product.price;
                    this.$formatNum($total += $price * item.amount,2)
                })
                return $total
            },
            shipping: function () {
                let $total = 0;
                this.cartList.forEach(item => {
                    if (item.product.inventory === 0) return false;
                    let $price = item.product.logistic;
                    this.$formatNum($total += $price * item.amount )
                })
                return $total
            },
            orderTotal: function () {
                return this.$formatNum(this.itemTotal + this.shipping, 2)
            }
        },
        methods: {
            affirmReceipt(item){
                this.verify(item,0).then(()=>{
                    this.$store.dispatch('getCart');
                    this.affirmData.show=false;
                })
            },
            removeItem(item){
                this.affirmData.show=true;
                this.affirmData.product = item
            },
            verify(item,amount){
                return new Promise(resolve => {
                    let params = {
                        product:{
                            id:item.product.id
                        },
                        amount:(amount || amount === 0 )? amount : item.amount
                    }
                    this.axios.post('/student/buyer/order/cart/put',params).then(res=>{
                        if(res.succeed && res.login){
                            this.$store.dispatch('getCart');
                            resolve(res)
                        }
                    })
                })
            },
            updateDefaultAddress() {
                // this.$store.dispatch('updateDefaultAddress', {id: this.defaultAddressRadio})
            },
            checkout() {
                //购物车为空提示
                if(!this.$store.state.address.isDefault){
                    this.warning = true;
                    return false;
                }
                //购物车无产品或者购买的产品无货提示
                let $list = this.cartList.filter(item=>{
                    return item.product.inventory >= item.amount
                })
                if($list.length<1){
                    this.warning2 = true;
                    return  false
                }

                let data = {
                    orders: []
                }
                let $order = {};
                $list.forEach(item => {
                    let productItem = {
                        amount: item.amount,
                        product: {
                            id: item.product.id,
                            user: {
                                id: item.product.user.id
                            }
                        }
                    }
                    Array.isArray($order[productItem.product.user.id]) ? $order[productItem.product.user.id].push(productItem) : $order[productItem.product.user.id] = [productItem]
                })

                for (let i in $order) {
                    data.orders.push({
                        product: $order[i]
                    })
                }
                let $address = {
                    receiptCode: this.$store.state.address.isDefault.receiptCode,
                    receiptName: this.$store.state.address.isDefault.receiptName,
                    receipt: this.$store.state.address.isDefault.receipt,
                    receiptPhone: this.$store.state.address.isDefault.receiptPhone,
                    hasCart: true,

                }
                this.axios.post('/student/order/buyer/create', Object.assign(data, $address)).then(res => {
                    if (res.succeed) {
                        let $params = {orders: []};
                        res.items.forEach(item => {
                            $params.orders.push({id: item.id})
                        })
                        this.axios.post('/student/order/buyer/payment', $params).then(res => {
                            if (res.succeed) {
                                this.checkoutSucceed = true;
                                setTimeout(() => {
                                    this.$emit('componentIndex', 3)
                                    this.checkoutSucceed = false;
                                }, 2000)
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    div.main-box {
        position: relative;
        overflow: hidden;
        border-radius: 0 0 20px 20px;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            border-radius: 0 0 20px 20px;
            transition: z-index 0s linear 0.3s, opacity 0.3s linear;
        }

        &.mask-layer:before {
            transition: z-index 0s linear 0s;
            opacity: 1;
            z-index: 9998;
        }

        div.box-wrap {
            width: 100%;
            height: 100%;

            div.box-header {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                > i {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    font-weight: bolder;
                    transform: translateY(-50%);
                    font-size: 18px;
                    padding: 10px;
                    cursor: pointer;

                    &:hover {
                        opacity: 0.8;
                    }
                }

                > span {
                    font-size: 18px;
                    color: #000000;
                    font-weight: bolder;
                }
            }

            div.box-content {
                position: relative;
                background: #edf6f9;

                div.box-content-wrap {
                    div.title {
                        padding: 12px;
                        font-size: 14px;
                        font-weight: bolder;
                    }

                    div.ship-wrap {
                        background: #FFFFFF;
                        color: #adadad;
                        font-size: 14px;

                        .ship-title {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            line-height: 48px;

                        }

                        .ship-default {
                            div.ship-default-add {
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                font-size: 14px;
                                font-weight: bolder;
                                margin-right: 16px;
                                cursor: pointer;
                                transition: color 0.3s linear;
                                color: #9e9e9e;
                                i {
                                    margin-right: 6px;
                                }
                                &:hover {
                                    transition: color 0.3s linear;
                                    color: #FDAD53;
                                }
                            }
                            div.address-wrap {
                                padding: 12px;
                                display: flex;
                                flex-direction: column;

                                div.receipt-list {
                                    display: flex;
                                    flex-direction: column;

                                    > span {
                                        margin-bottom: 6px;
                                    }
                                }
                            }

                            .el-radio {
                                display: flex;
                            }
                        }

                        span.address {
                            cursor: pointer;
                            color: #089bab;
                        }
                    }

                    div.product-list {
                        background: #FFFFFF;

                        > .item {
                            width: 100%;
                            padding: 12px;
                            display: flex;
                            box-sizing: border-box;
                            border-bottom: 1px solid #ebeef5;
                            position: relative;

                            div.img {
                                flex-shrink: 0;
                                width: 88px;
                                height: 88px;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            .product-info {
                                flex-shrink: 1;
                                font-size: 12px;
                                margin: 0 20px;

                                > .product-title {
                                    font-size: 14px;
                                    color: #000000;
                                    text-overflow: ellipsis;
                                    -webkit-box-orient: vertical;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 1;
                                    overflow: hidden;
                                    margin-bottom: 6px;
                                }

                                > .product-shipping {
                                    font-size: 12px;
                                    color: #adadad;
                                    margin-bottom: 6px;
                                    font-weight: lighter;
                                }

                                > .product-timeliness {
                                    font-size: 12px;
                                    color: #adadad;
                                    margin-bottom: 6px;
                                    font-weight: lighter;
                                }
                            }

                            .product-price {
                                flex-shrink: 0;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                align-items: flex-end;

                                div.promotion-price {
                                    display: flex;
                                    flex-direction: column;
                                    color: #000000;

                                    span {
                                        text-align: right;
                                    }

                                    > span.promotionPrice {
                                        margin-bottom: 10px;
                                    }

                                    > span.isPromotion {
                                        text-decoration: line-through;
                                        color: #adadad;
                                    }
                                }

                                div.product-num {
                                    margin-top: 30px;
                                    width: 60px;
                                }
                            }

                            div.stockout-wrap {
                                position: absolute;
                                left: 0;
                                top: 0;
                                bottom: 0;
                                right: 0;
                                margin: auto;
                                background: rgba(0, 0, 0, 0.1);

                                > span.btnn {
                                    padding: 2px 6px;
                                    background: #089bab;
                                    color: #ffffff;
                                    font-size: 14px;
                                    border-radius: 3px;
                                    bottom: 10px;
                                    position: absolute;
                                    left: 120px;
                                    cursor: pointer;
                                    box-shadow: 4px 4px 10px -5px #795548;

                                    &:hover {
                                        opacity: 0.8;
                                    }
                                }
                            }
                        }
                    }

                    div.order-summary {
                        background: #FFFFFF;
                        padding: 12px;
                        border-bottom: 1px solid #ebeef5;

                        > div {
                            line-height: 28px;
                            display: flex;
                            justify-content: space-between;
                        }
                    }

                    div.buy-info {
                        background: #FFFFFF;
                        color: #565656;
                        font-size: 12px;
                        padding: 12px;
                        line-height: 18px;
                    }
                }

                div.message-alert {
                    width: 100%;
                    padding: 20px 0;
                    background: #FFFFFF;
                    position: absolute;
                    bottom: -300px;
                    left: 0;
                    z-index: 9999;
                    transition: bottom 0.3s linear;
                    border-radius: 0 0 22px 22px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    &.active {
                        bottom: -52px;
                        transition: bottom 0.3s linear;

                        .img:before {
                            left: 100%;
                            transition: left 1s linear 0.3s;
                        }
                    }

                    > .img {
                        width: 80px;
                        height: 80px;
                        margin-bottom: 20px;
                        position: relative;

                        &:before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 0;
                            bottom: 0;
                            right: 0;
                            background: #FFFFFF;
                        }

                        > img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    > .txt {
                        font-weight: bolder;
                        margin-bottom: 10px;
                    }

                    > .price {
                        font-weight: lighter;
                        font-size: 12px;
                    }
                }
            }

            div.box-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 12px;
                box-sizing: border-box;
                box-shadow: 0 0 1px #373737;

                span.pay {
                    width: 100%;
                    height: 30px;
                    background: #ff8700;
                    color: #FFFFFF;
                    font-size: 14px;
                    font-weight: bolder;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 3px;
                    cursor: pointer;
                    transition: opacity 0.3s linear;

                    &:hover {
                        opacity: 0.8;
                        transition: opacity 0.3s linear;
                    }
                }
            }
        }

        div.box-wrap.empty {
            div.box-content {
                padding-top: 100px;

                > div.empty {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    > span.icon {
                        border: 1px solid #eeeeee;
                        border-radius: 50%;
                        width: 60px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background: #FFFFFF;
                        margin-bottom: 20px;

                        > i {
                            font-size: 32px;
                        }
                    }

                    > span.txt {
                        font-size: 18px;
                        font-weight: bolder;
                        margin-bottom: 20px;
                    }

                    > span.btn {
                        padding: 10px 20px;
                        background: #089bab;
                        border-radius: 4px;
                        margin-right: 0;
                        font-weight: bolder;
                    }
                }
            }
        }
    }
</style>
